// @flow
import SingleDatePicker from './SingleDatePicker'
import { createFormGroupField } from '@src/components/ui/FormGroup'

export default createFormGroupField(SingleDatePicker)
